/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { Drawer, Card, Form, Row, Col, Select, Checkbox } from 'antd';
import Input from '@ui/Input'
import TextArea from '@ui/TextArea'
import ActionButtonsBar from '@ui/ActionButtonsBar'
import '../CreateAmenity/styles.scss'
import { getGuestrooms, getAmenitiesForAllGuestRooms, upsertAmenitiesForGuestRooms } from '../Amenities/helpers'
import { validateFormHelper } from '../Amenities/helpers'
import redirectImg from 'Styles/assets/redirect.png'
import Loading from '../../../../components/Loading'
import { getOTACodes } from '@services/common'

interface editAmenityProps {
  editData: { 
    amenityType: string, 
    type: string, 
    includedInRates: string,
    details: string,
    amenityID: string,
    quantity: number,
    unitOfMeasure: string,
    currency: string,
    chargeAmount: number,
    description: string,
  },
  onClose: () => void,
  visible: boolean,
  setOperation: (a: string) => void,
  setCurrentRow: (a: []) => void,
  setDefKey: (a: string) => void,
  setSingleAmenity: (a: any) => void,
  reload: () => void
}

const EditAmenity = (props: editAmenityProps) => {
  const [form] = Form.useForm()
  const [requiredFlag] = useState(true)
  const [typeOptionsValues, setTypesOptionsValues] = useState([])
  const [currencyValues, setCurrencyValues] = useState([])
  const [ready, setReady] = useState(false)
  const [data, setData] = useState([])
  const [dataAllGuestRooms, setDataAllGuestRooms] = useState([])
  const [disableFlag, setDisableFlag] = useState<boolean>(true)
  const [amenityName, setAmenityName] = useState<string>('')

  const miscOptions = ['Amenity', 'Accessibility', 'Security']
  const unitOptions = [
    'Meters',
    'Millimeters',
    'Centimeters',
    'Yards',
    'Feet',
    'Inches',
    'Pixels',
  ]
  const Option = Select.Option


  const changeAmenityName = async (name: string) => {
    setReady(false)
    setAmenityName(name)
    data.map(({ amenities } : { amenities : []}, index) => {
      // @ts-expect-error
      data[index].checked = false
      // @ts-expect-error
      data[index].initial = false
      return amenities.map((amenitie : { type: string }) => {
        if (name.toLocaleLowerCase() === amenitie.type.toLocaleLowerCase()) {
          // @ts-expect-error
          data[index].checked = true
          // @ts-expect-error
          data[index].initial = true
        }
        return setData(data)
      })
    })

    setTimeout(() => setReady(true))
  }

  const onSelectAll = () => {
    setReady(false)
    data.map(({ amenities } : { amenities : []}, index) => {
      // @ts-expect-error
      return data[index].checked = true
    })

    validateForm()
    setTimeout(() => setReady(true))
  }

  const onSingleSelection = useCallback((e: any, idx: number) => {
    e.preventDefault()
    setReady(false)
    // @ts-expect-error
    data[idx].checked = e.target.checked

    setTimeout(() => setReady(true))
  }, [data])

  const onSave = async () => {
    const dataToCreateOrUpdate: any = data.filter(({ checked }) => checked)
    const getAllRoomsData: { guestrooms: [] }[] = dataAllGuestRooms.filter(({ amenityType  } : { amenityType: string }) => amenityType.toLowerCase() === amenityName.toLowerCase())
    const editBody: {}[] = []

    data.map(({ grid, checked } : { grid: number, checked: boolean }) => {
      if (getAllRoomsData.length > 0) {
        return getAllRoomsData.map(({ guestrooms }) => guestrooms.map(({ idGuestRoom, idAmenity, idAmenityLang, guestroom } : { idGuestRoom: number, idAmenity: number, idAmenityLang: string, guestroom: string }) => {
          if (idGuestRoom === grid) {
            editBody.push({
              idAmenity,
              idAmenityLang,
              idGuestRoom,
              guestroom,
              selected: checked
            })
            return dataToCreateOrUpdate
          }
          return dataToCreateOrUpdate
        })) 
      }
      return dataToCreateOrUpdate
    })

    const values = form.getFieldsValue()
    const body = {
      type: values.categorytype,
      amenityType: values.amenity,
      includedInRates: values.includedinrate,
      details: values.details, 
      amenityID: values.id,
      unitOfMeasure: values.unitofmeasure,
      currency: values.currency,
      chargeAmount: values.chargeamount,
      guestrooms: editBody
    }

    await upsertAmenitiesForGuestRooms(body)

    props.onClose()
    form.resetFields()  
    setTypesOptionsValues([])
    setDisableFlag(true)
    setReady(false)
    props.reload()
  }

  const getGuestRoomsData = useCallback(async () => {
    const { property: { guestrooms: { guestroom }}} = await getGuestrooms()
    const { guestRoomAmenitiesForAllRooms } = await getAmenitiesForAllGuestRooms()
    setData(guestroom)
    setDataAllGuestRooms(guestRoomAmenitiesForAllRooms)
  }, [])

  useEffect(() => {
    changeAmenityName(props.editData.amenityType)
  }, [data])

  const RoomTypes = useMemo(() => {
    return ready && data.map(({ name, id, checked, initial }, idx) => (
      <Col span={8} style={{ marginBottom: 24 }}>
        <Checkbox key={idx} onChange={(e: any) => {onSingleSelection(e, idx); validateForm();}} defaultChecked={checked}>
          <div style={{ position: 'absolute', top: -6, pointerEvents: 'none'}}>
            <span style={{ color: '#2D2D2D' }}>{name}</span>
            <br/>
            <span style={{ color: '#8E8E8E' }}>{id}</span>
          </div>
        </Checkbox>
        <img
          onClick={() => {
            props.setOperation('view')
            props.setCurrentRow(data[idx])
            props.setDefKey('7')
            props.setSingleAmenity(amenityName)
          }}
          src={redirectImg}
          alt='redirect to amenities'
          style={{
            marginLeft: 16,
            zIndex: 20,
            position: 'relative',
            top: -8,
            left: 46,
            cursor: 'pointer',
            display: checked && initial ? 'block' : 'none'
          }}/>
      </Col>
    ))
  }, [amenityName, data, onSingleSelection, props, ready])

  // validating the required values have been fufilled properly
  const validateForm = useCallback(() => {
    const selected: any[] = data.filter(({ checked }) => checked)
    if (data.length > 0 && selected.length > 0) {
      return validateFormHelper(form, setDisableFlag)
    } else {
      setDisableFlag(true)
    }
  }, [data, form])

  const getCurrencyData = useCallback(async () => {
    let res = await getOTACodes('CUR', '')
    setCurrencyValues(res.otacodes)
  }, [])

  useEffect(() => {
    props.visible && getGuestRoomsData()
    if (!props.visible) {
      form.resetFields()  
      setTypesOptionsValues([])
      setDisableFlag(true)
      setReady(false)
    }
    getCurrencyData()
  }, [form, getGuestRoomsData, props])

  return (
    <Drawer
      title="Edit Amenity" 
      placement="right" 
      onClose={props.onClose} 
      visible={props.visible} 
      width={976} 
      afterVisibleChange={() => {
        form.setFieldsValue({ 
          amenity: props.editData.amenityType, 
          categorytype: props.editData.type,
          includedinrate: props.editData.includedInRates,
          details: props.editData.details,
          id: props.editData.amenityID,
          quantity: props.editData.quantity,
          unitofmeasure: props.editData.unitOfMeasure,
          currency: props.editData.currency,
          chargeamount: props.editData.chargeAmount,
          description: props.editData.description
        }); 
      }}>
      <Card style={{ marginTop: -15, marginBottom: 65 }}> 
        <Form
          layout='vertical'
          form={form}
          name='basic'
          onValuesChange={validateForm}
          >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                label='Amenity / Accessibility / Security'
                name='categorytype'
                rules={[
                  {
                    required: requiredFlag,
                    message: 'This field is required',
                  },
                ]}>
                <Select allowClear showSearch placeholder='Please select' disabled={true}>
                  {miscOptions.map((item: string, i: number) => (
                    <Option key={`${item}-${i}`} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label='Amenity'
                name='amenity'
                rules={[
                  {
                    required: requiredFlag,
                    message: 'This field is required',
                  },
                ]}>
                <Select allowClear showSearch disabled={true}>
                {typeOptionsValues.map(
                  (item: { codeName: string }, i: number) => (
                    <Option key={`${item.codeName}-${i}`} value={item.codeName}>
                      {item.codeName}
                    </Option>
                  ),
                )}
              </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label='Included in Rate'
                name='includedinrate'
                rules={[
                  {
                    required: requiredFlag,
                    message: 'This field is required',
                  },
                ]}>
                <Select allowClear showSearch placeholder='Please select'>
                  <Option key={'yes-1'} value='Yes'>
                    Yes
                  </Option>
                  <Option key={'no-1'} value='No'>
                    No
                  </Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                label='Amenity Detail'
                name='details'
                /* extra={
                  isonEdit ? (
                    <span className="blue-font">
                      Lanyon Maximum length:50. Please input exact time (24 hour
                      clock, - ex: 00:00-06:00 ) in Type Detail if choosing Type
                      as “If no 24 hour security, what are the hours?” for
                      Security. Please input minutes in Type Detail if choosing
                      Type as “Emergency svc response time (minutes).
                    </span>
                  ) : null
                } */
                rules={[
                  {
                    max: 50,
                    message: 'You have reached the max character length of 50',
                  },
                  // { required: true, message: 'This field is required' },
                ]}>
                <Input maxLength={50} placeholder='Detail'/>
              </Form.Item>
            </Col>
          </Row>
          <br />
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                label='Amenity ID'
                name='id'>
                <Input placeholder='ID'/>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label='Quantity'
                name='quantity'
                tooltip={{
                  title: 'Please provide quantity of the amenities depending on its room type',
                  placement: 'bottomLeft'
                }}
                rules={[
                  {
                    pattern: /^\+?\d+$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input disabled={true} placeholder='Number'/>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label='Unit of Measure' name='unitofmeasure'>
                <Select allowClear showSearch placeholder='Please select'>
                  {unitOptions.map((item: string, i: number) => (
                    <Option key={`${item}-${i}`} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label='Currency' name='currency'>
                <Select allowClear showSearch placeholder='Please select'>
                  {currencyValues.map((item: { codeName: string }, i: number) => (
                    <Option key={`${item.codeName}-${i}`} value={item.codeName}>
                      {item.codeName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label='Charge Amount'
                name='chargeamount'
                rules={[
                  {
                    pattern: /^[+]?[0-9]*\.?[0-9]*$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input placeholder='Number'/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                label='Description'
                name='description'
                tooltip={{
                  title: 'Please provide quantity of the amenities depending on its room type',
                  placement: 'bottomLeft'
                }}
                rules={[
                  {
                    max: 500,
                    message: 'You have reached the max character length of 500',
                  },
                ]}>
                <TextArea maxLength={500} rows={3} className='disabled' disabled={true} placeholder='Provide description here...'/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            {ready && 
            <Col span={24} style={{ marginBottom: 26 }}>
              <span style={{ color: '#999999' }}> Room included </span>
              <b style={{ color: '#06789D', cursor: 'pointer', marginLeft: 16}} onClick={onSelectAll}>Select All</b>
              <p className='warning-text'>
                <b>PLEASE NOTE :</b> Any changes made to this amenity will be applied to ALL selected room types below.  If you deselect any room types, the amenity will be removed completely from those rooms.  If you wish to make an edit for select rooms only then please select each room individually in the Guest Room table and click the amenities tab at the top.
              </p>

            </Col>}
            {!ready && <div style={{ marginTop: '65%'}}> <Loading type={'large'} /> </div>}
            { ready && RoomTypes }
          </Row>
        </Form>
        <ActionButtonsBar
          onCancel={props.onClose}
          onSave={onSave}
          disabledSave={disableFlag}
          show={true}
        />
      </Card>
    </Drawer>
  )
}

export default EditAmenity
